/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMinusCircleFill: {
  name: 'minus-circle-fill';
  data: string;
} = {
  name: 'minus-circle-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm4 10a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1Z" fill="currentColor"/></svg>`,
};
